import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Scrolls to top on pathname change, or to the hash target when navigating to /#section.
 */
export default function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      const id = hash.replace('#', '');
      const scrollToTarget = () => {
        const el = document.getElementById(id);
        if (el) {
          el.scrollIntoView({ behavior: 'smooth', block: 'start' });
          return true;
        }
        return false;
      };

      // Lazy-loaded pages mount after navigation, so keep looking for the target for ~2s.
      if (!scrollToTarget()) {
        let tries = 0;
        const timer = window.setInterval(() => {
          tries += 1;
          if (scrollToTarget() || tries > 20) window.clearInterval(timer);
        }, 100);
        return () => window.clearInterval(timer);
      }
      return undefined;
    }

    window.scrollTo(0, 0);
    return undefined;
  }, [pathname, hash]);

  return null;
}
